import React, { Component } from "react";
import { AddCircleOutline, RemoveCircleOutline } from "@material-ui/icons";
import { connect } from "react-redux";
import Loading from "../../Loading";
import { getCurrencyIcon } from "../../../Helpers/currencyConverter";
class ProductQuantity extends Component {
  render() {
    const themeColor = this.props.themeColor
      ? this.props.themeColor
      : "#0099cc";

    if (!this.props.product) return <Loading />;
    const { product, settings } = this.props;
    const currency =
      this.props.language === "english"
        ? settings.currency_english
        : settings.currency_local;
    const currencyIcon = getCurrencyIcon(settings)
    return (
      <div
        style={{
          height: "60px",
          verticalAlign: "middle",
          marginTop: this.props.type == "bottom" ? 20 : 0,
        }}
      >
        <div
          className={"mt-3 ".concat(
            this.props.language == "english" ? "float-right " : "float-left "
          )}
          style={{ width: "150px", height: "30px" }}
        >
          {product.price !== undefined && this.props.showPrices ? (
            <span
              className={""
                .concat(
                  this.props.language == "english"
                    ? "float-left ml-3 rtl"
                    : "float-right mr-3"
                )
                .concat(currencyIcon)}
              style={{
                fontWeight: "bold",
                color: themeColor,
                font: "20px",
                direction: this.props.language == "english" ? "ltr" : "rtl",
                whiteSpace: "nowrap",
              }}
            >
              {`${product.price.toFixed(
                settings.currency_decimals
              )} ${currency}`}
            </span>
          ) : null}
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    language: state.store.language,
    themeColor: state.store.store.settings.dark,
    settings: state.store.store.settings,
    product: state.b2b.selectedProduct.product,
    showPrices: state.b2b?.distributor?.show_prices ?? false,
  };
};

export default connect(mapStateToProps)(ProductQuantity);
